import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Text, HeadingText, Root } from "@components";
import { imageUrlBuilder } from "@utils";
import { getDestinationList } from "@redux/teetime/actions";
import bg from "@assets/images/bg.png";

export const Traveling = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { destination } = useSelector((store) => store.teetimeReducer);
  const [imageExists, setImageExists] = useState(true);

  useEffect(() => {
    dispatch(getDestinationList());
  }, []);

  const checkImageExists = (url) => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setImageExists(true);
    };

    img.onerror = () => {
      setImageExists(false);
    };
  };

  return (
    <>
      {destination?.length > 0 && (
        <div className="py-10 bg-[#F5F5F5] ">
          <Root>
            <div className={`flex flex-col  items-center justify-center pb-2`}>
              <HeadingText className={`${Heading} font-semibold`}>
                {item?.attributes?.title || ""}
              </HeadingText>
              <Text
                className={`${SimpleText} font-light text-[#414141] lg:py-4 py-2 text-center`}
              >
                {item?.attributes?.description || ""}
              </Text>
            </div>
            <ul role="list" className={TravelingGrid}>
              {destination?.map((client) => {
                const image =
                  client?.image?.length > 0 && client?.image[0]?.url;

                checkImageExists(image);
                return (
                  <button
                    className="justify-self-center hover:shadow-[0px_0px_20px_0px_#cdcaec] rounded-lg overflow-hidden shadow drop-shadow-xl"
                    onClick={() => {
                      navigate(
                        `/destination/${client?.location.replace(/, /g, "-")}`,
                        { state: image }
                      );
                    }}
                    key={client?.id + client?.location}
                  >
                    <li className=" md:w-[360px] sm:w-[330px] xsm:w-[300px] w-full bg-[white] hover:text-primary  cursor-pointer ">
                      <div className={ImagesRoot}>
                        <img
                          src={imageExists ? image : bg}
                          alt={client.name}
                          className={ImageItem}
                        />
                      </div>
                      <dl className="-my-3 divide-gray-100 px-2 pb-4 text-sm leading-6 ">
                        <div className="flex justify-between gap-x-4 py-3">
                          <div className="lg:pt-6 lg:px-4 pt-4 px-2">
                            <div className="flex flex-row justify-between">
                              <Text
                                className={`lg:text-[20px] text-[18px] text-inherit`}
                              >
                                {client?.location}
                              </Text>
                            </div>
                          </div>
                        </div>
                      </dl>
                    </li>
                  </button>
                );
              })}
            </ul>
          </Root>
        </div>
      )}
    </>
  );
};

const Heading = `
lg:text-[28px]
text-[18px] `;

const SimpleText = `
lg:text-[18px] 
text-[15px]`;

const TravelingGrid = `
grid 
gap-x-6
gap-y-8 
xl1:grid-cols-3 
xl:grid-cols-2 
lg:grid-cols-2 
grid-cols-1 
`;

const ImagesRoot = `
h-[200px]
flex 
items-center 
gap-x-4 
border-gray-900/5 
bg-gray-50 `;

const ImageItem = `
h-full 
w-full 
flex-none 
rounded-lg 
bg-white 
object-cover 
ring-1 
ring-gray-900/10
`;
